const config = {
  url: "https://crudcrud.com/api/1154f245945749f4990ef0a274da3aa6",
};
export default config;
